import { useEffect, useState } from "react";
import LicenseService from "../../services/LicensesService";
import Input from "../Input/Input";
import Select from "../Select/Select";

export function DiscountReasonSelector({ value = null, setValue, disabled, ...props }) {
   const [reasons, setReasons] = useState([]);
   const [reason, setReason] = useState(null);

   async function fetchReasons() {
      const response = await LicenseService.getDiscountReasons();
      setReasons(response.data);
   }

   useEffect(() => {
      if (value) {
         const reasonFound = reasons?.length && reasons.find(r => r.name === value);
         if (reasonFound) {
            if (reason !== value) setReason(value);
         } else {
            if (reason !== 'Outro') setReason('Outro');
         }
      }
   }, [
      reasons,
      value
   ]);

   useEffect(() => {
      fetchReasons();
   }, []);

   const reasonFound = reasons?.length && reasons.find(r => r.name === value) && reason !== 'Outro';

   return (
      <div className="w-full grid grid-cols-2 gap-3">
         <div className={`${value == null || reasonFound ? 'col-span-2' : 'col-span-1'}`}>
            <Select
               labelText="Motivo de Desconto *"
               value={reason}
               onChange={({ target }) => {
                  setReason(target.value);
                  if (target.value !== 'Outro') {
                     setValue(target.value);
                  } else {
                     setValue(prev => !reasons?.find(r => r.name === prev) ? prev : '');
                  }
               }}
               disabled={disabled}
               options={[
                  ...reasons?.map((type) => ({
                     value: type.name,
                     text: type.name,
                  })),
                  {
                     value: 'Outro',
                     text: 'Outro',
                  }
               ]}
            />
         </div>
         {(value != null && !reasonFound) && (
            <div className="col-span-1">
               <Input
                  name="discountReason"
                  id="discountReason"
                  labelText="Qual o motivo? *"
                  value={value}
                  onChange={({ target }) =>
                     setValue(target.value)
                  }
                  disabled={disabled}
               />
            </div>
         )}
         {props.error && (
            <div className="col-span-2">
               <span className="error-message">
                  {props.error}
               </span>
            </div>
         )}
      </div>
   );
}